import React, { Component } from 'react'

class Input extends Component{
    render(){
        const { name, type, placeholder, onChange, onBlur, value, disabled, className } = this.props
        return(
            <div className={className}>
                <input type={type} 
                       name={name}
                       className="input-container"
                       value={value}
                       disabled={disabled}
                       placeholder={placeholder}
                       onChange={onChange} 
                       onBlur={onBlur}
                       required/>
            </div>
        )
    }
}

export default Input